import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PhotoPreparationService {
  prepare(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      const canvas = document.createElement('canvas');
      let settled = false;
      const finish = (error?: Error, result?: File) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        image.onload = image.onerror = null;
        image.src = '';
        URL.revokeObjectURL(url);
        canvas.width = canvas.height = 0;
        if (error) reject(error);
        else resolve(result!);
      };
      const timer = setTimeout(() => finish(new Error('Photo preparation timed out. Try a smaller JPG.')), 60000);
      image.onerror = () => finish(new Error('This photo cannot be opened. Please choose a JPG or PNG.'));
      image.onload = () => {
        if (settled) return;
        try {
          const scale = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          const context = canvas.getContext('2d');
          if (!context) throw new Error('Photo preparation is unavailable on this device.');
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(blob => {
            if (settled) return;
            if (!blob) return finish(new Error('This photo could not be prepared.'));
            finish(undefined, new File([blob], `${file.name.replace(/\.[^.]+$/, '') || 'site_photo'}.jpg`, { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.84);
        } catch (error) {
          finish(error instanceof Error ? error : new Error('Photo preparation failed.'));
        }
      };
      image.src = url;
    });
  }
}
